import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-editor-date",
  styleUrls: ["./editor-date.component.scss"],
  templateUrl: "./editor-date.component.html",
})
export class EditorDateComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @Input() date: Date = new Date();
  @Output() onChange: EventEmitter<Date> = new EventEmitter();

  inDate: Date = new Date();
  inTime: Date = new Date();
  showEditor: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.inDate = moment(this.date).toDate();
    this.inTime = moment(this.date).toDate();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  editing() {
    this.showEditor = true;
  }

  closeEditor() {
    this.showEditor = false;
  }

  save() {
    this.showEditor = false;
    const today = new Date();
    const dateString =
      moment(this.inDate ? this.inDate : today).format("YYYY-MM-DD") +
      " " +
      moment(this.inTime ? this.inTime : today).format("HH:mm");

    this.date = moment(dateString).toDate();

    this.onChange.emit(this.date);
  }

  dateChange() {
    const today = new Date();
    const dateString =
      moment(this.inDate ? this.inDate : today).format("YYYY-MM-DD") +
      " " +
      moment(this.inTime ? this.inTime : today).format("HH:mm");

    this.date = moment(dateString).toDate();

    this.onChange.emit(this.date);
  }
}
